import React from 'react';
import { Menu, MenuItem } from '@material-ui/core';

export default ({
  anchorEl,
  handleClose,
  handleDelete,
}) => (
  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
    <MenuItem >Solicitar opinión</MenuItem>
    {/* <MenuItem >Ir al mensaje</MenuItem> */}
    <MenuItem onClick={handleDelete}>Eliminar de contactos</MenuItem>
  </Menu>
);
